document.addEventListener('DOMContentLoaded', function() {
  let initialized = false;
  
  function initFooterAccordion() {
    if (window.innerWidth > 749 || initialized) return;
    
    const accordionHeaders = document.querySelectorAll('.footer .accordion-header');
    
    accordionHeaders.forEach(header => {
      // 移除旧的事件监听器
      header.removeEventListener('click', handleAccordionClick);
      // 添加新的事件监听器
      header.addEventListener('click', handleAccordionClick);
    });
    
    initialized = true;
  }
  
  function handleAccordionClick(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const accordionItem = this.closest('.accordion-item');
    const content = accordionItem.querySelector('.accordion-content');
    
    if (!content) return;
    
    if (accordionItem.classList.contains('active')) {
      // 关闭
      closeAccordion(accordionItem, content);
    } else {
      // 先关闭其他所有项
      document.querySelectorAll('.footer .accordion-item.active').forEach(item => {
        const itemContent = item.querySelector('.accordion-content');
        if (itemContent) {
          closeAccordion(item, itemContent);
        }
      });
      
      // 打开当前项
      openAccordion(accordionItem, content);
    }
  }
  
  function closeAccordion(item, content) {
    item.classList.remove('active');
    content.style.height = content.scrollHeight + 'px';
    // 强制重排
    content.offsetHeight;
    content.style.height = '0px';
  }
  
  function openAccordion(item, content) {
    item.classList.add('active');
    const inner = content.querySelector('.accordion-content__inner');
    if (inner) {
      content.style.height = '0px';
      content.offsetHeight;
      content.style.height = inner.scrollHeight + 'px';
      
      setTimeout(() => {
        if (item.classList.contains('active')) {
          content.style.height = 'auto';
        }
      }, 350);
    }
  }
  
  initFooterAccordion();
  
  // 防抖处理
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      initialized = false;
      if (window.innerWidth <= 749) {
        initFooterAccordion();
      } else {
        // 桌面端清理
        document.querySelectorAll('.footer .accordion-item').forEach(item => {
          item.classList.remove('active');
          const content = item.querySelector('.accordion-content');
          if (content) content.style.height = '';
        });
      }
    }, 250);
  });
});